module.exports = __webpack_public_path__ + "static/media/zameen-opal-v3.049ae3e4.jpg";